<template>
    <!-- 导航 -->
    <NavBar :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'">
        <template v-slot:title>
            <span class="nav-title">我的预约</span>
        </template>
    </NavBar>

    <main :class="{ new_year_bg_color: $newYearStyle }">
        <div class="date-box" v-for="(item, time) in data" :key="time">
            <section class="time-title">
                <p class="date-time">{{ item.release_day }} {{ item.release_time }}</p>
            </section>
            <router-link :to="'/product/' + product.id" class="cont-box" v-for="product in item.products" :key="product.id">
                <div class="img-box">
                    <img :src="product.cover" />
                </div>
                <section class="obj-content">
                    <span class="title">{{ product.name }}</span>
                    <p class="sell-time">发售时间 {{ product.release_time }}</p>
                    <div class="price-box">
                        <section class="price">
                            <span>{{ product.price > 0 ? ('¥ ' + product.price) : '免费' }}</span>
                        </section>
                        <p class="icon-box" v-if="priorities.indexOf(product.id) > -1">
                            <img class="buy-icon" src="@/assets/images/lightning.png" fit="cover" />
                            可优先{{ product.price > 1 ? '购买' : '领取' }}
                            <van-icon name="arrow" size="10" color="#3FDABD" />
                        </p>
                    </div>
                </section>
            </router-link>
        </div>
    </main>

    <div v-show="false" class="list-null">
        <van-empty
            :image="require('@/assets/images/kong.png')"
            description="暂无订单"
        />
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>